import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminGetDownloads } from "@/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function AdminDownloads() {
  const [downloads, setDownloads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminGetDownloads()
      .then(setDownloads)
      .catch(() => toast.error("Could not load downloads"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-sm text-muted-foreground" data-testid="admin-downloads-loading">Loading downloads…</p>;

  return (
    <div data-testid="admin-downloads-page">
      <h1 className="text-3xl text-foreground">Guide downloads</h1>
      <p className="mt-2 text-sm text-muted-foreground">Emails captured through gated lead magnets.</p>
      <div className="mt-8 overflow-x-auto border border-border bg-card" data-testid="admin-downloads-table">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Guide</TableHead>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {downloads.map((d) => (
              <TableRow key={d.download_id} data-testid={`admin-download-row-${d.download_id}`}>
                <TableCell className="whitespace-nowrap text-xs text-muted-foreground">{new Date(d.created_at).toLocaleDateString("en-AE")}</TableCell>
                <TableCell className="font-medium">{d.magnet_title}</TableCell>
                <TableCell>{d.name || ","}</TableCell>
                <TableCell className="text-xs">{d.email}</TableCell>
              </TableRow>
            ))}
            {downloads.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} className="py-12 text-center text-sm text-muted-foreground" data-testid="admin-downloads-empty">
                  No downloads yet.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
